/**
 * These are up to date as of Aug 22, 2024. Regenerate the list using this query:
 *   ```
       select type || ' = ''' || type || ''',' from building_suite_contract_conditions
       order by type asc
 *   ```
 */
export var CONTRACT_CONDITION_TYPE;
(function (CONTRACT_CONDITION_TYPE) {
    CONTRACT_CONDITION_TYPE["AUTO_EQUITY_PURCHASE"] = "AUTO_EQUITY_PURCHASE";
    CONTRACT_CONDITION_TYPE["BETA"] = "BETA";
    CONTRACT_CONDITION_TYPE["CARRYING_COST"] = "CARRYING_COST";
    CONTRACT_CONDITION_TYPE["CO_FINANCING"] = "CO_FINANCING";
    CONTRACT_CONDITION_TYPE["CONDO_FEES"] = "CONDO_FEES";
    CONTRACT_CONDITION_TYPE["CONTRACTUAL_RENT"] = "CONTRACTUAL_RENT";
    CONTRACT_CONDITION_TYPE["DOWNPAYMENT_FIXED"] = "DOWNPAYMENT_FIXED";
    CONTRACT_CONDITION_TYPE["DOWNPAYMENT_PERCENTAGE"] = "DOWNPAYMENT_PERCENTAGE";
    CONTRACT_CONDITION_TYPE["EQUITY_BOOST"] = "EQUITY_BOOST";
    CONTRACT_CONDITION_TYPE["EQUITY_GROWTH_ANNUAL_EFFECTIVE"] = "EQUITY_GROWTH_ANNUAL_EFFECTIVE";
    CONTRACT_CONDITION_TYPE["FIXED_GROWTH_VALUATION_METHOD"] = "FIXED_GROWTH_VALUATION_METHOD";
    CONTRACT_CONDITION_TYPE["HAAS_FEE_FIXED"] = "HAAS_FEE_FIXED";
    CONTRACT_CONDITION_TYPE["HAAS_FEE_PRORATED"] = "HAAS_FEE_PRORATED";
    CONTRACT_CONDITION_TYPE["HOME_ONBOARDING_FEE"] = "HOME_ONBOARDING_FEE";
    CONTRACT_CONDITION_TYPE["HOME_PRICE_INDEX_VALUATION_METHOD"] = "HOME_PRICE_INDEX_VALUATION_METHOD";
    CONTRACT_CONDITION_TYPE["HOME_SEARCH_BUDGET"] = "HOME_SEARCH_BUDGET";
    CONTRACT_CONDITION_TYPE["HOME_SEARCH_DEPOSIT_AMOUNT"] = "HOME_SEARCH_DEPOSIT_AMOUNT";
    CONTRACT_CONDITION_TYPE["HOME_SEARCH_DOWNPAYMENT"] = "HOME_SEARCH_DOWNPAYMENT";
    CONTRACT_CONDITION_TYPE["HOME_SEARCH_MONTHLY_PAYMENT"] = "HOME_SEARCH_MONTHLY_PAYMENT";
    CONTRACT_CONDITION_TYPE["HOME_SEARCH_FINAL_HOME_VALUE"] = "HOME_SEARCH_FINAL_HOME_VALUE";
    CONTRACT_CONDITION_TYPE["INTEREST_RATE"] = "INTEREST_RATE";
    CONTRACT_CONDITION_TYPE["INTEREST_RATE_ANNUAL"] = "INTEREST_RATE_ANNUAL";
    CONTRACT_CONDITION_TYPE["LIMITER_RATE"] = "LIMITER_RATE";
    CONTRACT_CONDITION_TYPE["LOCKER"] = "LOCKER";
    CONTRACT_CONDITION_TYPE["MAINTENANCE"] = "MAINTENANCE";
    CONTRACT_CONDITION_TYPE["MINIMUM_GROSS_INCOME"] = "MINIMUM_GROSS_INCOME";
    CONTRACT_CONDITION_TYPE["OCCUPANCY_PAYMENT"] = "OCCUPANCY_PAYMENT";
    CONTRACT_CONDITION_TYPE["OCCUPANCY_TERM"] = "OCCUPANCY_TERM";
    CONTRACT_CONDITION_TYPE["OWNERSHIP_SAVINGS_REINVESTMENT"] = "OWNERSHIP_SAVINGS_REINVESTMENT";
    CONTRACT_CONDITION_TYPE["PARKING"] = "PARKING";
    CONTRACT_CONDITION_TYPE["PROPERTY_TAX"] = "PROPERTY_TAX";
    CONTRACT_CONDITION_TYPE["REDEMPTION_NOTICE_PERIOD_OWNER_RESIDENT"] = "REDEMPTION_NOTICE_PERIOD_OWNER_RESIDENT";
    CONTRACT_CONDITION_TYPE["REDEMPTION_NOTICE_PERIOD_PROPERTY_OWNER"] = "REDEMPTION_NOTICE_PERIOD_PROPERTY_OWNER";
    CONTRACT_CONDITION_TYPE["REDEMPTION_POLICY_PENALTY"] = "REDEMPTION_POLICY_PENALTY";
    CONTRACT_CONDITION_TYPE["REDEMPTION_POLICY_THRESHOLD"] = "REDEMPTION_POLICY_THRESHOLD";
    CONTRACT_CONDITION_TYPE["RENT_RESET_PERIOD"] = "RENT_RESET_PERIOD";
    CONTRACT_CONDITION_TYPE["RESIDENT_ONBOARDING_FEE"] = "RESIDENT_ONBOARDING_FEE";
    CONTRACT_CONDITION_TYPE["RESIDENT_SOURCING_FEE"] = "RESIDENT_SOURCING_FEE";
    CONTRACT_CONDITION_TYPE["SALES_TAX"] = "SALES_TAX";
    CONTRACT_CONDITION_TYPE["SUITE_INSURANCE"] = "SUITE_INSURANCE";
    CONTRACT_CONDITION_TYPE["TENANT_RENT"] = "TENANT_RENT";
    CONTRACT_CONDITION_TYPE["THIRD_PARTY_LOCKER"] = "THIRD_PARTY_LOCKER";
    CONTRACT_CONDITION_TYPE["THIRD_PARTY_PARKING"] = "THIRD_PARTY_PARKING";
})(CONTRACT_CONDITION_TYPE || (CONTRACT_CONDITION_TYPE = {}));
export var CONTRACT_CONDITION_FORMULA;
(function (CONTRACT_CONDITION_FORMULA) {
    CONTRACT_CONDITION_FORMULA["PERCENTAGE"] = "PERCENTAGE";
    CONTRACT_CONDITION_FORMULA["FIXED"] = "FIXED";
    CONTRACT_CONDITION_FORMULA["BINARY"] = "BINARY";
    CONTRACT_CONDITION_FORMULA["YEAR"] = "YEAR";
})(CONTRACT_CONDITION_FORMULA || (CONTRACT_CONDITION_FORMULA = {}));
//# sourceMappingURL=Contract.js.map